/* ============================================================
   MUSE DISC — Header JS
   ============================================================ */

(function () {
  const header     = document.getElementById('header');
  const menuToggle = document.getElementById('menu-toggle');
  const mobileNav  = document.getElementById('mobile-nav');
  const cartToggle = document.getElementById('cart-toggle');

  if (!header) return;

  // --- Transparent / solid on scroll -----------------------
  // RAF-throttled: only touches the DOM when state actually changes,
  // and only once per animation frame (not on every scroll pixel).
  const HERO_THRESHOLD = 80;
  let isSolid = false;
  let rafPending = false;

  function applyHeaderState() {
    rafPending = false;
    const shouldBeSolid = window.scrollY > HERO_THRESHOLD;
    if (shouldBeSolid === isSolid) return; // no change — skip DOM mutation
    isSolid = shouldBeSolid;
    header.classList.toggle('header--solid', isSolid);
    header.classList.toggle('header--transparent', !isSolid);
  }

  function onScroll() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(applyHeaderState);
  }

  applyHeaderState();
  window.addEventListener('scroll', onScroll, { passive: true });

  // --- Mobile menu toggle ----------------------------------
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      mobileNav.setAttribute('aria-hidden', String(!isOpen));
      document.body.classList.toggle('no-scroll', isOpen);
    });

    mobileNav.querySelectorAll('.header__mobile-nav-link').forEach(link => {
      link.addEventListener('click', () => {
        mobileNav.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('no-scroll');
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        mobileNav.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('no-scroll');
      }
    });
  }

  // --- Cart toggle -----------------------------------------
  if (cartToggle) {
    cartToggle.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('cart:open'));
    });
  }
})();
